import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-down-icon",
  "use": "arrow-down-icon-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"arrow-down-icon\">\n    <path d=\"M13.4658 6.93463C13.4658 5.84811 12.5287 4.96732 11.3726 4.96732L3 4.96732L3 3L11.3726 3C13.6847 3 15.5589 4.76159 15.5589 6.93463L15.5589 17.0718L19.5199 13.349L21 14.7401L14.3396 21L7.6792 14.7401L9.15929 13.349L13.4658 17.3966L13.4658 6.93463Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol